import actions from "./actions"

const initialState = {
    vehicles: [],
    vehicle: {},
    customer: {},
    location: {},
    search: null,
    pinDetails: {},
    vehiclesLocations: [],
    vehicleLocationDetails:{},
    startStop: [],
    newStartStop: [],
    poiList:[],
    poiListDetails:{},
    newPoiList:{},
    customerPoi:[],
    customerPoiDetails:{},
    vehiclesRefresh:{refresh:true},
    rpm: [],
    vehiclesConfiguration:[],
    vehicleGroups: [],
    vehiclesGroup: [],
    vehicleGroupDetails: {},
    vehicleUngrouped: [],
    vehicleDetails:{},
    vehiclesWithConfig: [],
    pdfLoading: false,
    fuelTankVehicle: [],
    fuelTankVehicleCombined: [],
    disturbanceRefuel: [],
    disturbanceLoss: [],
    topBarBottom: []
};

export default function vehicleReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_DATA:
            return {...state, vehicles: action.payload};
        case actions.SET_LOCATION:
            return {...state, location: action.payload};
        case actions.SET_VEHICLE_DETAILS:
            return {...state, vehicle: action.payload, vehicleDetails:action.payload, customer: action.payload.customer};
        case actions.SET_PIN_DETAILS:
            return {...state, pinDetails: action.payload};
        case actions.SET_INITIAL:
            return {...state, vehicle: {}, customer: {}, location: {}, search: null, startStop: [], vehicleDetails:{}};
        case actions.SET_INITIAL_PINS:
            return {...state, pinDetails: {}};
        case actions.SET_VEHICLES_LOCATIONS:
            return {...state, vehiclesLocations: action.payload};
        case actions.SET_INITIAL_VEHICLES_LOCATION:
            return {...state, vehiclesLocations: {}};
        case actions.SET_VEHICLE_LOCATION_DETAILS:
            return {...state, vehicleLocationDetails: action.payload};
        case actions.SET_VEHICLES_REFRESH:
            return  {...state, vehiclesRefresh: action.payload};
        case actions.SET_VEHICLE_START_STOP:
            return {...state, startStop: action.payload};
        case actions.SET_VEHICLE_NEW_START_STOP:
            return {...state, newStartStop: action.payload};
        case actions.SET_INITIAL_VEHICLE_LOCATION_DETAILS:
            return {...state, vehicleLocationDetails: {}};
        case actions.SET_VEHICLES_SEARCH:
            return {...state, search: action.payload};
        case actions.SET_INITIAL_VEHICLES_SEARCH:
            return {...state, search: null};
        case actions.SET_USER_POI:
            return {...state, poiList: action.payload};
        case actions.SET_USER_POI_DETAILS:
            return {...state, poiListDetails: action.payload};
        case actions.SET_INITIAL_NEW_POI:
            return {...state, newPoiList: action.payload};
        case actions.SET_CUSTOMER_POI:
            return {...state, customerPoi: action.payload};
        case actions.SET_CUSTOMER_POI_DETAILS:
            return {...state, customerPoiDetails: action.payload};
        case actions.SET_INITIAL_CUSTOMER_POI_DETAILS:
            return {...state, customerPoiDetails:{}};
        case actions.SET_VEHICLES_CONFIGURATION:
            return {...state, vehiclesConfiguration: action.payload};
        case actions.SET_VEHICLE_RPM:
            return {...state, rpm: action.payload};
        case actions.SET_VEHICLE_GROUPS:
            return {...state, vehicleGroups: action.payload};
        case actions.SET_VEHICLES_GROUP:
            return {...state, vehiclesGroup: action.payload};
        case actions.SET_VEHICLE_DETAILS_GROUP:
            return {...state, vehicleGroupDetails: action.payload};
        case actions.SET_VEHICLES_UNGROUPED:
            return {...state, vehicleUngrouped: action.payload};
        case actions.SET_VEHICLES_WITH_CONFIG:
            return {...state, vehiclesWithConfig: action.payload};
        case actions.SET_INITIAL_VEHICLES_WITH_CONFIG:
            return {...state, vehiclesWithConfig: []};
        case actions.SET_PDF_LOADING:
            return {...state, pdfLoading: action.payload}
        case actions.SET_VEHICLES_FUEL_TANK_VEHICLE:
            return {...state, fuelTankVehicle: action.payload }
        case actions.SET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED:
            return {...state, fuelTankVehicleCombined: action.payload }
        case actions.SET_VEHICLE_DISTURBANCE_REFUEL:
            return {...state, disturbanceRefuel: action.payload }
        case actions.SET_VEHICLE_DISTURBANCE_LOSS:
            return {...state, disturbanceLoss: action.payload }
        case actions.SET_BOTTOM_OF_TOP_BAR:
            return {...state, topBarBottom: action.payload }

        default:
            return state;
    }
}